import { AbstractComponent } from "appworks/components/abstract-component";
import { ComponentFactory } from "appworks/components/factories/component-factory";
import { BigWinComponent, BigWinTierConfig, CountMode } from "slotworks/components/bigwin/big-win-component";

export class TGRBigWinFactory implements ComponentFactory {

    constructor(
        protected countMode: CountMode = CountMode.LINEAR,
        protected upgrade: boolean = true,
        protected tiers?: BigWinTierConfig[]
    ) {
        if (!tiers) {
            this.tiers = [
                {
                    threshold: 20,
                    countTime: 4000,
                    waitTime: 4000,
                    scene: "bigwin"
                },
                {
                    threshold: 50,
                    countTime: 5500,
                    waitTime: 4000,
                    scene: "megawin"
                },
                {
                    threshold: 100,
                    countTime: 9500,
                    waitTime: 4000,
                    scene: "supermegawin"
                }
            ];
        }
    }

    public build(): AbstractComponent {
        const bigWin = new BigWinComponent();
        bigWin.countupMode = this.countMode;
        bigWin.upgrade = this.upgrade;

        if (this.tiers) {
            for (const tier of this.tiers) {
                bigWin.addWinTier(tier);
            }
        }

        return bigWin;
    }
}
